import dayjs, { extend } from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

extend(relativeTime);

export const useDateString = (dateString: string) => {
    if (dateString === 'Just now') return { dateTimeAgo: 'Just now', dateFull: '' };

    const date = dayjs(new Date(dateString));
    const now = dayjs();

    const isJustNow = now.diff(date, 'minutes') < 10;
    const isToday = now.diff(date, 'days') < 1;
    const isThisYear = now.year() == date.year();

    let dateTimeAgo = date.format('MMM D YYYY');

    if (isJustNow) {
        dateTimeAgo = 'Just now';
    } else if (isToday) {
        dateTimeAgo = date.fromNow();
    } else if (isThisYear) {
        dateTimeAgo = date.format('MMM D');
    }

    const dateFull = date.format('MMM D, YYYY h:mm A');

    return { dateTimeAgo, dateFull };
};

export const useAgeString = (dateString?: string) => {
    if (!dateString) return { dateTimeAgo: undefined, dateFull: undefined };

    if (dateString === 'Just now') return { dateTimeAgo: 'Just now', dateFull: '' };

    const date = dayjs(new Date(dateString));
    const now = dayjs();

    const isJustNow = now.diff(date, 'minutes') < 10;
    const isToday = now.diff(date, 'days') < 1;
    const isThisWeek = now.diff(date, 'days') < 7;
    const isThisMonth = now.diff(date, 'weeks') < 4;
    const isThis18Months = now.diff(date, 'months') < 18;

    let dateTimeAgo: string;

    if (isJustNow) {
        dateTimeAgo = 'Just now';
    } else if (isToday) {
        const val = now.diff(date, 'hours');
        dateTimeAgo = `${val} hour${val > 1 ? 's' : ''}`;
    } else if (isThisWeek) {
        const val = now.diff(date, 'days');
        dateTimeAgo = `${val} day${val > 1 ? 's' : ''}`;
    } else if (isThisMonth) {
        const val = now.diff(date, 'weeks');
        dateTimeAgo = `${val} week${val > 1 ? 's' : ''}`;
    } else if (isThis18Months) {
        const val = now.diff(date, 'months');
        dateTimeAgo = `${val} month${val > 1 ? 's' : ''}`;
    } else {
        const val = now.diff(date, 'years');
        dateTimeAgo = `${val} year${val > 1 ? 's' : ''}`;
    }

    const dateFull = date.format('MMM D, YYYY h:mm A');

    return { dateTimeAgo, dateFull };
};
